// extracted by mini-css-extract-plugin
export var join = "ArticleMeta-module--join--2RU37";
export var label = "ArticleMeta-module--label--6P5N5";
export var linkWrapper = "ArticleMeta-module--linkWrapper--E53A3";
export var row = "ArticleMeta-module--row--FPHU-";